import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-remove\"><circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#001233\" /><path d=\"M13.186 6.058 12.168 5.04 9.113 8.095 6.058 5.04 5.04 6.058l3.055 3.055-3.055 3.055 1.018 1.018 3.055-3.055 3.055 3.055 1.018-1.018-3.055-3.055 3.055-3.055Z\" fill=\"#EFE0CA\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol